import { FC } from 'react'
import { selectSessionId } from 'src/app/session'
import HostActiveSession from 'src/components/session/HostActiveSession'
import HostInactiveSession from 'src/components/session/HostInactiveSession'
import { useAppSelector } from 'src/hooks'

type SessionProps = {
  id: string
  groupId: string
}

const Session: FC<SessionProps> = ({ id, groupId }) => {
  const activeSessionId = useAppSelector(selectSessionId)
  const isActive = id === activeSessionId

  return (
    <>
      {isActive ? (
        <HostActiveSession />
      ) : (
        <HostInactiveSession id={id} groupId={groupId} />
      )}
    </>
  )
}

export default Session
